import { AnalyticsEventsPair, makeEventsPair } from './AnalyticsEventBuilder';
import { Game } from '../../models/Game';
import { HomeAnalyticsAi } from './AI/HomeAnalyticsAi';

export class HomeAnalytics {
    aiAnalytics = new HomeAnalyticsAi();

    promoImpression(promoKey: string ): AnalyticsEventsPair {
        return makeEventsPair(
            null,
            this.aiAnalytics.promoImpression(promoKey),
        );
    }

    promoClick(key: string, index: number): AnalyticsEventsPair {
        return makeEventsPair(
            null,
            this.aiAnalytics.promoClick(key, index),
        );
    }
}
